var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"height":"24","width":"24","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M12 1v7a1 1 0 0 0 1 1h7v12a2 2 0 0 1-1.85 1.995L18 23H6a2 2 0 0 1-1.995-1.85L4 21V3a2 2 0 0 1 1.85-1.995L6 1zm3 13H9a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2zM14 1.586L19.414 7H14z","fill-rule":"evenodd"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }